import React from "react"

import { Link } from "gatsby"

import { ChildSelector } from "../helpers/ChildSelector"
import { GatsbyImage } from "gatsby-plugin-image"

import AdvancedBlogHelpers from "../helpers/AdvancedBlogHelpers"
import BlogHelpers from "../helpers/BlogHelpers"
import Spinner from "./_base/Spinner"

import { blogPathTranslator } from "../helpers/BlogPathTranslator"

import * as simpleBlogLatestSectionStyles from "../styles/SimpleBlogLatestSection.module.css"

import SimpleBlogLatestSectionFilters from "./SimpleBlogLatestSectionFilters"
import SimpleBlogLatestSectionFiltersMobile from "./SimpleBlogLatestSectionFiltersMobile"
import SimpleBlogLatestSectionSearch from "./SimpleBlogLatestSectionSearch"

import moment from "moment"

const FILTERS_ALWAYS_ON = false
const MOBILE_FILTERS = false

function SimpleBlogLatestSection(props) {
  const [settingsLoaded, updateState] = React.useState()
  const forceUpdate = React.useCallback(() => updateState({}), [])

  const categories = React.useRef({})
  const tags = React.useRef({})
  const baseFilters = React.useRef({
    cats: [],
    tags: [],
  })
  const blogUriRoot = React.useRef(
    blogPathTranslator(props.pageContext.language.slug)
  )

  const [activeFilters, setActiveFilters] = React.useState({
    cats: [],
    tags: [],
  })
  const [token, setSearchToken] = React.useState(``)
  const [loadingPosts, setLoadingPosts] = React.useState(true)
  const [resultsMetadata, setResultsMetadata] = React.useState({
    timestamp: null,
    currentPage: 0,
    numberOfPages: 0,
  })
  const [posts, setPosts] = React.useState([])

  const { content, posts: allPosts } = props
  const { wordpressUrl } = props.pageContext

  const loadBaseFilters = React.useCallback(
    classNames => BlogHelpers.loadFilters(classNames),
    []
  )

  const fetchPosts = React.useCallback(
    async (filters, token = null, pageNumber = undefined) => {
      const numberOfParticlesPerPage = 6
      // console.log(`fetchPosts`, baseFilters.current, filters)
      if (baseFilters.current && baseFilters.current.cats && baseFilters.current.cats.length === 0) {
        return BlogHelpers.fetchPostsAdvanced(
          // props.pageContext,
          token,
          BlogHelpers.updateFilters(filters, baseFilters.current),
          categories.current,
          tags.current,
          wordpressUrl,
          pageNumber,
          numberOfParticlesPerPage
        )
      }

      return BlogHelpers.fetchPosts(
        // props.pageContext,
        token,
        BlogHelpers.updateFilters(filters, baseFilters.current),
        categories.current,
        tags.current,
        wordpressUrl,
        pageNumber,
        numberOfParticlesPerPage
      )
    },
    [wordpressUrl]
  )

  const handleSearchTokenChange = async t => {
    setSearchToken(t)
    const fecthed = await fetchPosts(activeFilters, t)
    // console.log(fecthed)
    setPosts(fecthed.data)
    setResultsMetadata({
      timestamp: Date.now(),
      currentPage: fecthed.currentPage,
      numberOfPages: fecthed.numberOfPages,
    })
    setLoadingPosts(false)
  }

  const handleNextPage = async () => {
    const fecthed = await fetchPosts(
      activeFilters,
      token,
      resultsMetadata.currentPage + 1
    )
    setPosts(p => [...p, ...fecthed.data])
    setResultsMetadata({
      timestamp: Date.now(),
      currentPage: fecthed.currentPage,
      numberOfPages: fecthed.numberOfPages,
    })
    setLoadingPosts(false)
  }

  const handleCategoryFilterToggle = async filter => {
    console.log(`handleTagFilterToggle`, baseFilters.current, filter)
    if (baseFilters.current.cats.includes(filter.toLowerCase())) return

    let newFilters
    if (activeFilters.cats.indexOf(filter) === -1) {
      newFilters = {
        cats: [...activeFilters.cats, filter],
        tags: activeFilters.tags,
      }
    } else {
      newFilters = {
        cats: activeFilters.cats.filter(c => c !== filter),
        tags: activeFilters.tags,
      }
    }
    setActiveFilters(newFilters)
    setLoadingPosts(true)
    const fecthed = await fetchPosts(newFilters, token)
    console.log(fecthed)

    setPosts(fecthed.data)
    setResultsMetadata({
      timestamp: Date.now(),
      currentPage: fecthed.currentPage,
      numberOfPages: fecthed.numberOfPages,
    })
    setLoadingPosts(false)
  }

  const handleTagFilterToggle = async filter => {
    // console.log(`handleTagFilterToggle`, baseFilters.current, filter)
    if (baseFilters.current.tags.includes(filter.toLowerCase())) return

    let newFilters
    if (activeFilters.tags.indexOf(filter) === -1) {
      newFilters = {
        cats: activeFilters.cats,
        tags: [...activeFilters.tags, filter],
      }
    } else {
      newFilters = {
        cats: activeFilters.cats,
        tags: activeFilters.tags.filter(c => c !== filter),
      }
    }
    setActiveFilters(newFilters)
    setLoadingPosts(true)
    const fecthed = await fetchPosts(newFilters, token)
    // console.log(fecthed)
    setPosts(fecthed.data)
    setResultsMetadata({
      timestamp: Date.now(),
      currentPage: fecthed.currentPage,
      numberOfPages: fecthed.numberOfPages,
    })
    setLoadingPosts(false)
  }

  const businessUnitStyle = post => {
    const tagsList = post.categories.nodes

    const tags = tagsList.map(t => t.name.toLowerCase())

    if (tags.includes(`consulting`))
      return simpleBlogLatestSectionStyles.postItemConsulting
    if (tags.includes(`education`))
      return simpleBlogLatestSectionStyles.postItemEducation
    if (tags.includes(`technical`) || tags.includes(`code`))
      return simpleBlogLatestSectionStyles.postItemCode

    return ``
  }

  React.useEffect(() => {
    const loadTagsDictionary = async () => {
      categories.current = await BlogHelpers.getCategoriesDictionary(
        wordpressUrl
      )
      tags.current = await BlogHelpers.getTagsDictionary(wordpressUrl)
      baseFilters.current = await loadBaseFilters(props.className)

      forceUpdate()
    }

    loadTagsDictionary()
  }, [wordpressUrl, props.className, loadBaseFilters, forceUpdate])

  React.useEffect(() => {
    const loadBaseSettings = async () => {
      console.log('loadBaseSettings')
      /*  if (
        baseFilters.current.cats.length === 0 &&
        baseFilters.current.tags.length === 0
      ) {
        setPosts(allPosts, setLoadingPosts(false))
      } else { */
      setLoadingPosts(true)
      const fecthed = await fetchPosts(baseFilters.current)

      setPosts(fecthed.data, setLoadingPosts(false))
      setResultsMetadata({
        timestamp: Date.now(),
        currentPage: fecthed.currentPage,
        numberOfPages: fecthed.numberOfPages,
      })
      // }
    }

    if (tags.current && Object.keys(tags.current).length) loadBaseSettings()
  }, [allPosts, fetchPosts, settingsLoaded])

  // console.log(baseFilters.current, activeFilters, token)

  return (
    <div
      className={`${props.className} ${simpleBlogLatestSectionStyles.wrapper}`}
    >
      <div className={`row ${simpleBlogLatestSectionStyles.heading}`}>
        <div className={`col-12 ${simpleBlogLatestSectionStyles.titleWrapper}`}>
          <h2
            className={`${simpleBlogLatestSectionStyles.title}`}
            dangerouslySetInnerHTML={{
              __html: ChildSelector.select(
                content,
                `latest-post-header`,
                ChildSelector.SELECTOR_TYPE.INNER_HTML
              ),
            }}
          />
        </div>
      </div>
      <div className={`row ${simpleBlogLatestSectionStyles.searchField}`}>
        <div
          className={`col-12 ${simpleBlogLatestSectionStyles.searchFieldWrapper}`}
        >
          <SimpleBlogLatestSectionSearch
            placeholderText={`Search Cubewise for solutions, education and support`}
            resultsTimestamp={resultsMetadata.timestamp}
            onTokenChange={t => handleSearchTokenChange(t)}
          />
        </div>
      </div>

      {(props.className.trim().split(/\s+/).includes(`icw-blog-filters`) ||
        FILTERS_ALWAYS_ON) &&
        !MOBILE_FILTERS && (
          <SimpleBlogLatestSectionFilters
            settingsLoaded={!!settingsLoaded}
            fixedFilters={baseFilters.current.cats}
            selectedFilters={[
              ...baseFilters.current.cats,
              ...activeFilters.cats,
              ...baseFilters.current.tags,
              ...activeFilters.tags,
            ]}
            overrideFilters={BlogHelpers.loadFilterOverrides(props.className)}
            onCategoryFilterToggle={f => handleCategoryFilterToggle(f)}
            onTagFilterToggle={f => handleTagFilterToggle(f)}
          />
        )}

      {(props.className.trim().split(/\s+/).includes(`icw-blog-filters`) ||
        FILTERS_ALWAYS_ON) &&
        MOBILE_FILTERS && (
          <SimpleBlogLatestSectionFiltersMobile
            settingsLoaded={!!settingsLoaded}
            fixedFilters={baseFilters.current.cats}
            selectedFilters={[
              ...baseFilters.current.cats,
              ...activeFilters.cats,
              ...baseFilters.current.tags,
              ...activeFilters.tags,
            ]}
            overrideFilters={BlogHelpers.loadFilterOverrides(props.className)}
            onCategoryFilterToggle={f => handleCategoryFilterToggle(f)}
            onTagFilterToggle={f => handleTagFilterToggle(f)}
          />
        )}

      {loadingPosts && (
        <div className={`row ${simpleBlogLatestSectionStyles.postList}`}>
          <div className={`col-12`}>
            <Spinner message={`Loading posts for you, tons of them`} />
          </div>
        </div>
      )}

      <div className={`row ${simpleBlogLatestSectionStyles.postList}`}>
        {!loadingPosts && (!posts || posts.length === 0) && (
          <p>No posts found</p>
        )}
        {posts &&
          BlogHelpers.relevant(posts, activeFilters).map(p => (
            <div
              key={p.id}
              className={`col-12 ${simpleBlogLatestSectionStyles.postItemWrapper
                } ${simpleBlogLatestSectionStyles.postItem} ${businessUnitStyle(
                  p
                )}`}
            >
              <div
                className={`${simpleBlogLatestSectionStyles.postItemContent}`}
              >
                <p className={`${simpleBlogLatestSectionStyles.date}`}>
                  {moment(p.date).format("MMM D YYYY")}
                </p>

                {/*  <p className={`${simpleBlogLatestSectionStyles.author}`}>
                  Published by Cubewise Team
                  {p.author && p.author.node && p.author.node.name}
                </p> */}
                <div className={`${simpleBlogLatestSectionStyles.tagList}`}>
                  {p.tags &&
                    p.tags.nodes &&
                    p.tags.nodes.map((tag, indx) => (
                      <span
                        className={`${simpleBlogLatestSectionStyles.tag}`}
                        key={indx}
                      >
                        {tag.name}
                      </span>
                    ))}
                </div>
                <p
                  className={`${simpleBlogLatestSectionStyles.title}`}
                  dangerouslySetInnerHTML={{
                    __html: p.title,
                  }}
                />
                {p.thumbnail && (
                  <div
                    className={`${simpleBlogLatestSectionStyles.featuredImage}`}
                  >
                    <GatsbyImage image={p.thumbnail} alt={p.title} />
                  </div>
                )}
                {p.fimg_url && (
                  <div
                    className={`${simpleBlogLatestSectionStyles.featuredImageRemote}`}
                  >
                    <img src={p.fimg_url} alt={p.title} />
                  </div>
                )}
                <p
                  className={`${simpleBlogLatestSectionStyles.excerpt}`}
                  dangerouslySetInnerHTML={{
                    __html: p.excerpt,
                  }}
                ></p>
              </div>
              <div className={`${simpleBlogLatestSectionStyles.readmoreBtn}`}>
                {p.uri.toLowerCase().startsWith(`http`) && (
                  <a href={p.uri} target="_blank">Read full article</a>
                )}
                {!p.uri.toLowerCase().startsWith(`http`) && (
                  <Link
                  className={simpleBlogLatestSectionStyles.postItem}
                  to={`/${blogUriRoot.current}${p.uri}`}
                >
                  Read full article
                </Link>
                )}
              </div>
            </div>
          ))}
        {!!resultsMetadata &&
          !!resultsMetadata.currentPage &&
          !!resultsMetadata.numberOfPages &&
          resultsMetadata.numberOfPages > resultsMetadata.currentPage && (
            <div className={`col-12 ${simpleBlogLatestSectionStyles.loadMore}`}>
              <a
                href="#!"
                className={`${simpleBlogLatestSectionStyles.loadMoreButton}`}
                onClick={evt => {
                  evt.preventDefault()
                  handleNextPage()
                }}
              >
                Load more
              </a>
            </div>
          )}
      </div>
    </div>
  )
}

export default SimpleBlogLatestSection
